
export const role_admin = "admin";
export const role_super_admin = "super admin";
export const role_operator = "operator";
export const secret_encryption_key = "BSSSecretForRIL";
export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];